import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchRepairRequestProblemStateKeysQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.WorkOrdersConnectionArgs>;
  languages?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type FetchRepairRequestProblemStateKeysQuery = { __typename?: 'Query', repairRequestProblemStateKeys: { __typename?: 'WorkOrdersProblemStateKeyGraphqlConnection', totalCount: number, pageInfo: { __typename?: 'WorkOrdersPageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ __typename?: 'WorkOrdersProblemStateKeyGraphqlEdge', node: { __typename?: 'RepairRequestProblemStateKey', stateKey: string, label?: string | null } }> } };

export const FetchRepairRequestProblemStateKeysDocument = gql`
    query FetchRepairRequestProblemStateKeys($pagination: WorkOrdersConnectionArgs, $languages: [String!]) {
  repairRequestProblemStateKeys(pagination: $pagination) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      node {
        stateKey
        label(languages: $languages)
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchRepairRequestProblemStateKeysGQL extends Apollo.Query<FetchRepairRequestProblemStateKeysQuery, FetchRepairRequestProblemStateKeysQueryVariables> {
    override document = FetchRepairRequestProblemStateKeysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }